import { get } from "@visactor/vutils";

import { Factory } from "../core/factory";

export function getComponentThemeFromOption(type, chartTheme) {
    return get(chartTheme, `component.${type}`);
}

export function getFormatFunction(formatMethod, formatter, text, datum) {
    if (formatMethod) return {
        formatFunc: formatMethod,
        args: [ text, datum ]
    };
    const formatterImpl = Factory.getFormatter();
    return formatter && formatterImpl ? {
        formatFunc: formatterImpl,
        args: [ text, datum, formatter ]
    } : {};
}
//# sourceMappingURL=util.js.map